import { c as _c } from "react/compiler-runtime";
import { ActionIcon, Tooltip } from '@mantine/core';
import { useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { HiPencil, HiCheck } from 'react-icons/hi';
import { isArray, unique } from 'remeda';
import { StyleProps } from 'shared/ui/uiType';
import { doSafe } from 'shared/promise';
import { twJoin, twMerge } from 'tailwind-merge';
import { match } from 'ts-pattern';
import { UseQueryString } from 'utils/useQueryString';
import { ZodRawShape } from 'zod';
export const useEditingState = () => {
  const $ = _c(3);
  const [editing, setEditing] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = v => setEditing(v);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== editing) {
    t1 = {
      editing,
      setEditing: t0
    };
    $[1] = editing;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
type UseEditing = ReturnType<typeof useEditingState>;
export const useEditingQsArray = <T extends ZodRawShape, P extends keyof T>({
  id,
  qs,
  prop
}: {
  id: string;
  qs: UseQueryString<T>;
  prop: P;
}): UseEditing => {
  const a = doSafe(qs.query[prop], a => isArray(a) ? a as string[] : undefined) ?? [];
  const editing = qs.query[prop]?.includes(id);
  const setEditing = (v: boolean) => {
    const newIds = v ? unique([...a, id]) : a.filter(i => i != id);
    qs.setQuery({
      [prop]: newIds
    } as any);
  };
  return {
    editing,
    setEditing
  };
};
export const EditingButton = t0 => {
  const $ = _c(34);
  let T0;
  let T1;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== t0) {
    const {
      editing,
      setEditing,
      isDirty,
      className,
      style,
      ...props
    } = t0;
    const colorClass = match(isDirty).with(true, _temp).with(false, _temp2).otherwise(_temp3);
    T1 = Tooltip;
    const t8 = editing ? "click to exit edit mode" : "edit";
    let t9;
    if ($[10] !== t8) {
      t9 = <div>{t8}</div>;
      $[10] = t8;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    const t10 = isDirty != null && editing && <div className={twMerge("text-sm", colorClass)}><span className=" mr-1">changes</span><span>{isDirty ? "saving..." : "saved"}</span></div>;
    if ($[12] !== t10 || $[13] !== t9) {
      t7 = <div className="flex flex-col gap-1">{t9}{t10}</div>;
      $[12] = t10;
      $[13] = t9;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    t5 = props;
    if ($[15] !== className) {
      t6 = twMerge("ml-auto", className);
      $[15] = className;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    T0 = ActionIcon;
    t1 = "md";
    t2 = style;
    if ($[17] !== editing || $[18] !== setEditing) {
      t3 = () => setEditing(!editing);
      $[17] = editing;
      $[18] = setEditing;
      $[19] = t3;
    } else {
      t3 = $[19];
    }
    t4 = editing ? <FaCheckCircle className={twJoin("transition-colors duration-300 ease-in-out", colorClass)} /> : <HiPencil />;
    $[0] = t0;
    $[1] = T0;
    $[2] = T1;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    T0 = $[1];
    T1 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[20] !== T0 || $[21] !== t1 || $[22] !== t2 || $[23] !== t3 || $[24] !== t4) {
    t8 = <T0 size={t1} style={t2} onClick={t3}>{t4}</T0>;
    $[20] = T0;
    $[21] = t1;
    $[22] = t2;
    $[23] = t3;
    $[24] = t4;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== t5 || $[27] !== t6 || $[28] !== t8) {
    t9 = <div {...t5} className={t6}>{t8}</div>;
    $[26] = t5;
    $[27] = t6;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== T1 || $[31] !== t7 || $[32] !== t9) {
    t10 = <T1 label={t7}>{t9}</T1>;
    $[30] = T1;
    $[31] = t7;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
};
function _temp() {
  return "fill-orange-600 text-orange-500";
}
function _temp2() {
  return "fill-green-600 text-green-500";
}
function _temp3() {}